<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('stateCohort.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [hasSubfilters]="true" [multiSelectAgencies]="true" [allAgenciesCheckbox]="true" [multiSelectRatingPeriods]="true" [is2025]="is2025"
    [displaySite]="false" [displayClassroom]="false" [displayDownload]="false" [requiredFields]="requiredFields" [showSubfilterCheckAll]="false"
    [showReportBtnText]="t('actions.sendRequest')" (showReportClicked)="showReport($event)" [omitTestAgencies]="true" [displayCounty]="true">
  </drdp-report-search>
</div>
</ng-container>
